import Enums from './enums';
import { fromUtcToDeviceTimeZone, fromUtcToDeviceTimeZoneDateOnly, fromUtcToDeviceTimeZoneTimeOnly, fromUtcToTimeZone, fromUtcToTimeZoneDateOnly, fromUtcToTimeZoneTimeOnly } from './dateFormatter';
import { isListNotEmpty, isNotNullOrUndefined, isObjectNotEmpty, isStringNotEmpty } from './objectUtils';
import { capitalize, orderBy, startCase } from 'lodash';
import { isUpperCase } from './validationUtils';
import states from './states.json';

export const toYesNo = (booleanValue) => {
    if (isNotNullOrUndefined(booleanValue)) {
        if (booleanValue === true) {
            return 'Yes';
        } else {
            return 'No';
        }
    } else {
        return 'No';
    }
};

export const toCommaSeparatedList = (list) => {
    if (isListNotEmpty(list)) {
        return list.filter(i => isStringNotEmpty(i)).join(', ');
    } else {
        return '';
    }
};

export const toCommaSeparatedNameList = (list) => {
    if (isListNotEmpty(list)) {
        return list.map(i => i.name).filter(i => isStringNotEmpty(i)).join(', ');
    } else {
        return '';
    }
};

export const toFirstNameLastName = (user) => {
    let name = '';
    if (isObjectNotEmpty(user)) {
        if (isStringNotEmpty(user.firstName) && isStringNotEmpty(user.lastName)) {
            name = `${user.firstName} ${user.lastName}`;
        }
    }

    return name;
};

export const toName = (user) => {
    let name = '';
    if (isObjectNotEmpty(user)) {
        if (isStringNotEmpty(user.firstName) && isStringNotEmpty(user.lastName)) {
            name = `${user.firstName}${isStringNotEmpty(user.middleName) ? ' ' + user.middleName.charAt(0) : ''} ${user.lastName}${isStringNotEmpty(user.suffix) ? ' ' + toFormattedString('Suffix', user.suffix) : ''}`;
        }
    }

    return name;
};

export const toFirstNameLastInitial = (user) => {
    let name = '';
    if (isObjectNotEmpty(user)) {
        if (isStringNotEmpty(user.firstName) && isStringNotEmpty(user.lastName)) {
            name = `${user.firstName} ${user.lastName?.substring(0, 1)}`;
        }
    }

    return name;
};

export const toFormattedPhoneNumber = (phoneNumberValue) => {
    if (isNotNullOrUndefined(phoneNumberValue)) {
        //Filter only numbers from the input
        let cleaned = ('' + phoneNumberValue).replace(/\D/g, '');

        //Check if the input is of correct
        let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

        if (match) {
            //Remove the matched extension code
            //Change this to format for any country code.
            let intlCode = (match[1] ? '+1 ' : '+1 ')
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }

        return '';
    } else {
        return '';
    }
};

export const toPhoneNumberLocal = (phoneNumberValue) => {
    if (isNotNullOrUndefined(phoneNumberValue)) {
        //Filter only numbers from the input
        let cleaned = ('' + phoneNumberValue).replace(/\D/g, '');

        //Check if the input is of correct
        let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

        if (match) {
            //Remove the matched extension code
            //Change this to format for any country code.
            let intlCode = (match[1] ? '' : '');
            return [intlCode, match[2], match[3], match[4]].join('');
        }

        return '';
    } else {
        return '';
    }
};

export const toE164PhoneNumber = (phoneNumberValue) => {
    if (isNotNullOrUndefined(phoneNumberValue)) {
        //Filter only numbers from the input
        let cleaned = ('' + phoneNumberValue).replace(/\D/g, '');

        //Check if the input is of correct
        let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

        if (match) {
            //Remove the matched extension code
            //Change this to format for any country code.
            let intlCode = (match[1] ? '+1' : '+1')
            return [intlCode, match[2], match[3], match[4]].join('');
        }

        return '';
    } else {
        return '';
    }
};

export const toPhoneNumberDigitsOnly = (phoneNumberValue) => {
    if (isNotNullOrUndefined(phoneNumberValue)) {
        //Filter only numbers from the input
        let cleaned = ('' + phoneNumberValue).replace(/\D/g, '');

        //Check if the input is of correct
        let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

        if (match) {
            //Remove the matched extension code
            //Change this to format for any country code.
            let intlCode = (match[1] ? '1' : '1')
            return [intlCode, match[2], match[3], match[4]].join('');
        }

        return '';
    } else {
        return '';
    }
};

export const toFormattedMoney = (moneyValue, decPlacesValue = null) => {
    // console.log(moneyValue)
    if (isNotNullOrUndefined(moneyValue)) {
        let number = moneyValue ? ('' + moneyValue).replace('$', '').replace(',', '') : 0;
        let numberValue = Number(number);
        let decPlaces = decPlacesValue !== null && !isNaN(decPlacesValue) ? decPlacesValue : 2;
        let decSep = ".";
        let thouSep = ",";
        let dollarSign = "$";
        let sign = numberValue < 0 ? "-" : "";

        numberValue = Math.abs(numberValue);

        // guarantees that the number will have two parts
        numberValue = numberValue.toFixed(decPlaces);

        let parts = numberValue.toString().split(decSep);
        //console.log(parts)
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
        // if (parts.length > 1) {
        //     parts[1] = (parts[1].length > desPlaces ? parts[1].substring(0, desPlaces - 1) : (parts[1].length < desPlaces ? parts[1] + '0' : parts[1]);
        // }
        // if (parts.length === 1) {
        //     let trailingCharacters = '';
        //     for (let i = 0; i < decPlaces; i++) {
        //         trailingCharacters += '0';
        //     }
        //     parts.push(trailingCharacters);
        // }
        return sign + dollarSign + parts.join(decSep);
        // let i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
        // let j = i.length;
        // j = j > 3 ? j % 3 : 0;
        // let dollarSign = "$";

        // return sign + dollarSign +
        //     (j ? i.substr(0, j) + thouSep : "") +
        //     i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        //     (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
    } else {
        return '';
    }
};

export const toFormattedDecimal = (decimalValue, decPlacesValue = null, decSepValue = null, thouSepValue = null) => {
    if (isNotNullOrUndefined(decimalValue)) {
        let number = decimalValue ? decimalValue : 0;
        let numberValue = Number(number);
        let decPlaces = decPlacesValue !== null && !isNaN(decPlacesValue) ? decPlacesValue : 2;
        let decSep = decSepValue ? decSepValue : ".";
        let thouSep = thouSepValue ? thouSepValue : ",";

        decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces;
        decSep = typeof decSep === "undefined" ? "." : decSep;
        thouSep = typeof thouSep === "undefined" ? "," : thouSep;
        let sign = numberValue < 0 ? "-" : "";

        numberValue = Math.abs(numberValue);

        // guarantees that the number will have two parts
        numberValue = numberValue.toFixed(decPlaces);

        let parts = numberValue.toString().split(decSep);
        //console.log(parts)
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
        // if (parts.length > 1) {
        //     parts[1] = (parts[1].length > desPlaces ? parts[1].substring(0, desPlaces - 1) : (parts[1].length < desPlaces ? parts[1] + '0' : parts[1]);
        // }
        // if (parts.length === 1) {
        //     let trailingCharacters = '';
        //     for (let i = 0; i < decPlaces; i++) {
        //         trailingCharacters += '0';
        //     }
        //     parts.push(trailingCharacters);
        // }
        return sign + parts.join(decSep);
        // let i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
        // let j = i.length;
        // j = j > 3 ? j % 3 : 0;
        // let dollarSign = "$";

        // return sign + dollarSign +
        //     (j ? i.substr(0, j) + thouSep : "") +
        //     i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        //     (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
    } else {
        return '';
    }
};

// takes decimal value, multiplies by 100 and adds the percentage symbol
export const toFormattedPercentage = (value) => {
    if (!isNaN(value) && isNotNullOrUndefined(value)) {
        return `${(value * 100).toFixed(2)}%`;
    } else {
        return '';
    }
};

const pad = (n) => {
    return (n < 10 ? "0" + n : n);
};

// takes decimal value for number of minutes and converts it into days, hours, minutes
export const toFormattedMinutesCountdown = (value) => {
    let minutes = value;
    let days = Math.floor(minutes / 24 / 60);
    let hoursLeft = Math.floor((minutes) - (days * 1440));
    let hours = Math.floor(hoursLeft / 60);
    let remainingMinutes = Math.floor((hoursLeft) - (hours * 60));

    let eta = (days > 0 ? pad(days) + 'd' : '') + (hours > 0 ? (days > 0 ? ' ' : '') + pad(hours) + 'h' : '') + (remainingMinutes > 0 ? (days > 0 || hours > 0 ? ' ' : '') + pad(remainingMinutes) + 'm' : '');
    //let eta = pad(days) + ":" + pad(hours) + ":" + pad(remainingMinutes);
    if (minutes === 0) {
        eta = "Completed";
    }

    return eta;
};

// takes decimal value for number of minutes and converts it into days, hours, minutes, seconds
export const toFormattedSecondsCountdown = (value) => {
    let seconds = value;
    let days = Math.floor(seconds / 24 / 60 / 60);
    let hoursLeft = Math.floor((seconds) - (days * 86400));
    let hours = Math.floor(hoursLeft / 3600);
    let minutesLeft = Math.floor((hoursLeft) - (hours * 3600));
    let minutes = Math.floor(minutesLeft / 60);
    let remainingSeconds = Math.floor((minutesLeft) - (minutes * 60));
    //let remainingSeconds = seconds % 60;

    let eta = (days > 0 ? pad(days) + 'd' : '') + (hours > 0 ? (days > 0 ? ' ' : '') + pad(hours) + 'h' : '') + (minutes > 0 ? (days > 0 || hours > 0 ? ' ' : '') + pad(minutes) + 'm' : '') + (remainingSeconds > 0 ? (days > 0 || hours > 0 || minutes > 0 ? ' ' : '') + pad(remainingSeconds) + 's' : '');
    //let eta = pad(days) + ":" + pad(hours) + ":" + pad(minutes) + ":" + pad(remainingSeconds);
    if (seconds === 0) {
        eta = "Completed";
    }

    return eta;
};

export const toFormattedTimeRange = (startTime, endTime, timeZone) => {
    return `${toFormattedString("MomentTime", startTime, null, timeZone)} - ${toFormattedString("MomentTime", endTime, null, timeZone)}`;
};

// formats address to one line string
export const toAddressOneLine = (streetAddress1, streetAddress2, city, state, postalCode, country, address = null) => {
    if (isObjectNotEmpty(address)) {
        streetAddress1 = address.streetAddress1;
        streetAddress2 = address.streetAddress2;
        city = address.city;
        state = address.state;
        postalCode = address.postalCode;
        country = address.country;
    }

    return `${isStringNotEmpty(streetAddress1) ? streetAddress1 + '' : ''}${isStringNotEmpty(streetAddress2) ? ', ' + streetAddress2 : ''}${isStringNotEmpty(city) ? ', ' + city + ', ' : ''}${isStringNotEmpty(state) ? state + ' ' : ''}${isStringNotEmpty(postalCode) ? postalCode + ' ' : ''}${isStringNotEmpty(country) ? country : ''}`;
};

// formats address to one line string
export const toAddressTwoLines = (streetAddress1, streetAddress2, city, state, postalCode, country, address = null) => {
    if (isObjectNotEmpty(address)) {
        streetAddress1 = address.streetAddress1;
        streetAddress2 = address.streetAddress2;
        city = address.city;
        state = address.state;
        postalCode = address.postalCode;
        country = address.country;
    }

    return {
        line1: `${isStringNotEmpty(streetAddress1) ? streetAddress1 + '' : ''}${isStringNotEmpty(streetAddress2) ? ', ' + streetAddress2 : ''}`,
        line2: `${isStringNotEmpty(city) ? city + ', ' : ''}${isStringNotEmpty(state) ? state + ' ' : ''}${isStringNotEmpty(postalCode) ? postalCode + ' ' : ''}${isStringNotEmpty(country) ? country : ''}`
    };
};

export const toStringCapitalizeFirstLetter = (value) => {
    if (isStringNotEmpty(value)) {
        if (isUpperCase(value) && value.trim().includes('-')) {
            return value.trim().split('-').flatMap(i => startCase(i.toLowerCase())).join('-');
        }
        if (value.trim().includes('-')) {
            return value.trim().split('-').flatMap(i => startCase(i.toLowerCase())).join('-');
        }
        if (isUpperCase(value) && value.trim().includes(' ')) {
            return value.trim().split(' ').flatMap(i => startCase(i.toLowerCase())).join(' ');
        }
        if (isUpperCase(value)) {
            return value.trim().charAt(0).toUpperCase() + value.toLowerCase().slice(1);
        }
        if (value.trim().includes(' ')) {
            return value.trim().split(' ').flatMap(i => startCase(i.toLowerCase())).join(' ');
        }
        return value.trim().charAt(0).toUpperCase() + value.slice(1);
    }

    return '';
};

export const convertToLettersAndSpacesOnly = (value) => {
    if (isStringNotEmpty(value)) {
        return value.trim().replace(/[^a-zA-Z ]/g, "");
    }

    return '';
};

export const convert_accented_characters = (str) => {
    var conversions = {};
    conversions['ae'] = 'ä|æ|ǽ';
    conversions['oe'] = 'ö|œ';
    conversions['ue'] = 'ü';
    conversions['Ae'] = 'Ä';
    conversions['Ue'] = 'Ü';
    conversions['Oe'] = 'Ö';
    conversions['A'] = 'À|Á|Â|Ã|Ä|Å|Ǻ|Ā|Ă|Ą|Ǎ';
    conversions['a'] = 'à|á|â|ã|å|ǻ|ā|ă|ą|ǎ|ª';
    conversions['C'] = 'Ç|Ć|Ĉ|Ċ|Č';
    conversions['c'] = 'ç|ć|ĉ|ċ|č';
    conversions['D'] = 'Ð|Ď|Đ';
    conversions['d'] = 'ð|ď|đ';
    conversions['E'] = 'È|É|Ê|Ë|Ē|Ĕ|Ė|Ę|Ě';
    conversions['e'] = 'è|é|ê|ë|ē|ĕ|ė|ę|ě';
    conversions['G'] = 'Ĝ|Ğ|Ġ|Ģ';
    conversions['g'] = 'ĝ|ğ|ġ|ģ';
    conversions['H'] = 'Ĥ|Ħ';
    conversions['h'] = 'ĥ|ħ';
    conversions['I'] = 'Ì|Í|Î|Ï|Ĩ|Ī|Ĭ|Ǐ|Į|İ';
    conversions['i'] = 'ì|í|î|ï|ĩ|ī|ĭ|ǐ|į|ı';
    conversions['J'] = 'Ĵ';
    conversions['j'] = 'ĵ';
    conversions['K'] = 'Ķ';
    conversions['k'] = 'ķ';
    conversions['L'] = 'Ĺ|Ļ|Ľ|Ŀ|Ł';
    conversions['l'] = 'ĺ|ļ|ľ|ŀ|ł';
    conversions['N'] = 'Ñ|Ń|Ņ|Ň';
    conversions['n'] = 'ñ|ń|ņ|ň|ŉ';
    conversions['O'] = 'Ò|Ó|Ô|Õ|Ō|Ŏ|Ǒ|Ő|Ơ|Ø|Ǿ';
    conversions['o'] = 'ò|ó|ô|õ|ō|ŏ|ǒ|ő|ơ|ø|ǿ|º';
    conversions['R'] = 'Ŕ|Ŗ|Ř';
    conversions['r'] = 'ŕ|ŗ|ř';
    conversions['S'] = 'Ś|Ŝ|Ş|Š';
    conversions['s'] = 'ś|ŝ|ş|š|ſ';
    conversions['T'] = 'Ţ|Ť|Ŧ';
    conversions['t'] = 'ţ|ť|ŧ';
    conversions['U'] = 'Ù|Ú|Û|Ũ|Ū|Ŭ|Ů|Ű|Ų|Ư|Ǔ|Ǖ|Ǘ|Ǚ|Ǜ';
    conversions['u'] = 'ù|ú|û|ũ|ū|ŭ|ů|ű|ų|ư|ǔ|ǖ|ǘ|ǚ|ǜ';
    conversions['Y'] = 'Ý|Ÿ|Ŷ';
    conversions['y'] = 'ý|ÿ|ŷ';
    conversions['W'] = 'Ŵ';
    conversions['w'] = 'ŵ';
    conversions['Z'] = 'Ź|Ż|Ž';
    conversions['z'] = 'ź|ż|ž';
    conversions['AE'] = 'Æ|Ǽ';
    conversions['ss'] = 'ß';
    conversions['IJ'] = 'Ĳ';
    conversions['ij'] = 'ĳ';
    conversions['OE'] = 'Œ';
    conversions['f'] = 'ƒ';
    for (var i in conversions) {
        var re = new RegExp(conversions[i], "g");
        str = str.replace(re, i);
    }
    return str;
};

export const cleanUpName = (name) => {
    // removes accented characters, mac apostrophe, superscript characters, numbers, and special characters other than apostrophes or dash that are part of a word
    return convert_accented_characters(name).replace("’", "'").replace(/[\u2070-\u209f\u00b0-\u00be]+/g, '').replace(/'\B|[^a-zA-Z'-? ]/g, "").trim();

    //.replace(/[^a-zA-Z0-9]/g,'_')
};

export const toNotesString = (notes) => {
    if (isListNotEmpty(notes)) {
        let orderedNotes = orderBy(notes, ['modifiedAt'], ['desc']);

        return orderedNotes.map((note) => { return `[${note.noteName}: ${note.noteBody}]`; }).join(', ');
    }

    return '';
};

// This method will remove hyphens (but no spaces) on the first replace, 
// and in the second replace it will condense consecutive spaces into a single hyphen.
export const convertToSlug = (value = '', separator = '-') => {
    if (isStringNotEmpty(value)) {
        return value.toString()
            .normalize('NFD')                   // split an accented letter in the base letter and the acent
            .replace(/[\u0300-\u036f]/g, '')   // remove all previously split accents
            .toLowerCase()
            .trim()
            .replace(/\./g, ' ')
            .replace(/[^a-z0-9 ]/g, '')   // remove all chars not letters, numbers and spaces (to be replaced)
            .replace(/\s+/g, separator);
    }

    return '';
};

export const convertToSku = (value = '', separator = '-') => {
    if (isStringNotEmpty(value)) {
        return value.toString()
            .normalize('NFD')                   // split an accented letter in the base letter and the acent
            .replace(/[\u0300-\u036f]/g, '')   // remove all previously split accents
            .toUpperCase()
            .trim()
            .replace(/\./g, ' ')
            .replace(/[^A-Z0-9 ]/g, '')   // remove all chars not letters, numbers and spaces (to be replaced)
            .replace(/\s+/g, separator);
    }

    return '';
};

export const toProperAddressCase = (value) => {
    if (isStringNotEmpty(value)) {
        let addressParts = value.trim().split(' ');
        // console.log(addressParts)
        return addressParts.map(i => {
            if (i.length < 4) {
                return toStringCapitalizeFirstLetter(i);
            } else {
                return startCase(capitalize(i));
            }
        }).join(' ');
    }

    return '';
};

// Add commas to a number
export const numberWithCommas = (x, decimal = 0) => {
    return x.toLocaleString('en-US', { minimumFractionDigits: decimal });
};

// function to get time value in hh:mm AM | PM format
export const getTimeValue = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
};

// function to get date value in Month Name DD, YYYY format
export const getDateValue = (date) => {
    const month = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    const yyyy = date.getFullYear();
    let mm = date.getMonth();
    let dd = date.getDate();
    var today = month[mm] + ' ' + dd + ', ' + yyyy;
    return today;
};

// function to generate slug or ID with slug format
export const getSlug = (text) => {
    text = text.toLowerCase();
    text = text.replace(/ /g, '-').replace(/[^\w-]+/g, '');
    return text;
};

// function to apply currency symbol with two digits decimal values
export const convertToCurrency = (value) =>
    '$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

// Get the random number between min and max value
export const getRandomNo = (min = 0, max = 100) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};

// Get the color name/value based on given status
export const getStatusColor = (itemstatus) => {
    let color = '';
    switch (itemstatus) {
        case 'In Progress':
            color = 'info';
            break;
        case 'Pending':
            color = 'warning';
            break;
        case 'Finished':
            color = 'success';
            break;
        case 'Cancel':
            color = 'danger';
            break;
        default:
            color = 'primary';
    }
    return color;
};

// Get the color name/value based on given status
export const getCategoryColor = (category) => {
    let color = '';
    switch (category) {
        case 'Saas Services':
        case 'Entertainment':
        case 'Extra':
            color = 'info';
            break;
        case 'Design':
            color = 'warning';
            break;
        case 'Marketing':
            color = 'success';
            break;
        case 'Development':
            color = 'danger';
            break;
        case 'SEO':
            color = 'primary';
            break;
        default:
            color = 'primary';
    }
    return color;
};

// Get the file extension from given file name
export const getFileExtension = (filename) => {
    const extension = filename.split('.').pop();
    return extension;
};

export const toStateName = (stateAbbreviation) => {
    return states.find(i => i.abbreviation === stateAbbreviation)?.name ?? '';
};

// customers only ever see "Cancelled".
export const toCustomerSubscriptionStatusLabel = (status) => {
    if (status === 'PENDING_CANCEL') return 'Cancelled';
    if (status === 'ACTIVE') return 'Active';
    return Enums.SubscriptionStatuses.getValueByName(status) || '';
};

export const toFormattedString = (dataType, value, units = null, timeZone = null) => {
    if (isNotNullOrUndefined(value)) {
        let formattedValue = null;
        if (dataType === 'String') {
            formattedValue = value;
        } else if (dataType === 'PhoneNumber') {
            formattedValue = toFormattedPhoneNumber(value);
        } else if (dataType === 'FirstNameLastName') {
            formattedValue = toFirstNameLastName(value);
        } else if (dataType === 'Name') {
            formattedValue = toName(value);
        } else if (dataType === 'Address') {
            formattedValue = toAddressOneLine(value);
        } else if (dataType === 'Temperature') {
            formattedValue = `${value}${String.fromCharCode(176)}${Enums.TemperatureUnits.getValueByName(units)}`;
        } else if (dataType === 'Weight') {
            formattedValue = `${value} ${Enums.WeightUnits.getValueByName(units)}`;
        } else if (dataType === 'Length') {
            formattedValue = `${value} ${Enums.LengthUnits.getValueByName(units)}`;
        } else if (dataType === 'Distance') {
            formattedValue = `${value} ${Enums.DistanceUnits.getValueByName(units)}`;
        } else if (dataType === 'Volume') {
            formattedValue = `${value} ${Enums.VolumeUnits.getValueByName(units)}`;
        } else if (dataType === 'Time') {
            formattedValue = `${value} ${Enums.TimeUnits.getValueByName(units)}`;
        } else if (dataType === 'MinutesCountdown') {
            formattedValue = toFormattedMinutesCountdown(value);
        } else if (dataType === 'SecondsCountdown') {
            formattedValue = toFormattedSecondsCountdown(value);
        } else if (dataType === 'Boolean') {
            formattedValue = toYesNo(value);
        } else if (dataType === 'Percentage') {
            formattedValue = toFormattedPercentage(value);
        } else if (dataType === 'Money') {
            formattedValue = `${toFormattedMoney(value)}${units ? ' ' + Enums.Currencies.getValueByName(units) : ''}`;
        } else if (dataType === 'Decimal') {
            formattedValue = toFormattedDecimal(value, null, null, null);
        } else if (dataType === 'MomentDateTime') {
            if (isStringNotEmpty(timeZone)) {
                formattedValue = fromUtcToTimeZone(value, timeZone);
            } else {
                formattedValue = fromUtcToDeviceTimeZone(value);
            }
        } else if (dataType === 'MomentDate') {
            if (isStringNotEmpty(timeZone)) {
                formattedValue = fromUtcToTimeZoneDateOnly(value, timeZone);
            } else {
                formattedValue = fromUtcToDeviceTimeZoneDateOnly(value);
            }
        } else if (dataType === 'MomentTime') {
            if (isStringNotEmpty(timeZone)) {
                formattedValue = fromUtcToTimeZoneTimeOnly(value, timeZone);
            } else {
                formattedValue = fromUtcToDeviceTimeZoneTimeOnly(value);
            }
        } else if (dataType === 'ShipmentStatus') {
            formattedValue = Enums.ShipmentStatuses.getValueByName(value);
        } else if (dataType === 'Currency') {
            formattedValue = Enums.Currencies.getValueByName(value);
        } else if (dataType === 'Count') {
            formattedValue = Enums.Counts.getValueByName(value);
        } else if (dataType === 'YesNo') {
            formattedValue = Enums.YesNo.getValueByName(String(value));
        } else if (dataType === 'DayOfWeek') {
            formattedValue = Enums.DayOfWeek.getValueByName(value);
        } else if (dataType === 'TimeUnit') {
            formattedValue = Enums.TimeUnits.getValueByName(value);
        } else if (dataType === 'DistanceUnit') {
            formattedValue = Enums.DistanceUnits.getValueByName(value);
        } else if (dataType === 'WeightUnit') {
            formattedValue = Enums.WeightUnits.getValueByName(value);
        } else if (dataType === 'LengthUnit') {
            formattedValue = Enums.LengthUnits.getValueByName(value);
        } else if (dataType === 'VolumeUnit') {
            formattedValue = Enums.VolumeUnits.getValueByName(value);
        } else if (dataType === 'TemperatureUnit') {
            formattedValue = Enums.TemperatureUnits.getValueByName(value);
        } else if (dataType === 'UnitOfMeasure') {
            formattedValue = Enums.UnitOfMeasure.getValueByName(value);
        } else if (dataType === 'TimeZone') {
            formattedValue = Enums.TimeZones.getValueByName(value);
        } else if (dataType === 'USATimeZone') {
            formattedValue = Enums.USATimeZones.getValueByName(value);
        } else if (dataType === 'Gender') {
            formattedValue = Enums.Genders.getValueByName(value);
        } else if (dataType === 'Race') {
            formattedValue = Enums.Races.getValueByName(value);
        } else if (dataType === 'Ethnicity') {
            formattedValue = Enums.Ethnicities.getValueByName(value);
        } else if (dataType === 'PrimaryMemberRelationship') {
            formattedValue = Enums.PrimaryMemberRelationships.getValueByName(value);
        } else if (dataType === 'InsuranceRank') {
            formattedValue = Enums.InsuranceRanks.getValueByName(value);
        } else if (dataType === 'OrderStatus') {
            formattedValue = Enums.OrderStatuses.getValueByName(value);
        } else if (dataType === 'SubscriptionStatus') {
            formattedValue = Enums.SubscriptionStatuses.getValueByName(value);
        } else if (dataType === 'CallStatus') {
            formattedValue = Enums.CallStatuses.getValueByName(value);
        } else if (dataType === 'ContactMethod') {
            formattedValue = Enums.ContactMethods.getValueByName(value);
        } else if (dataType === 'CallWindowPreference') {
            formattedValue = Enums.CallWindowPreferences.getValueByName(value);
        } else if (dataType === 'Suffix') {
            formattedValue = Enums.Suffixes.getValueByName(value);
        } else if (dataType === 'InsuranceStatus') {
            formattedValue = Enums.InsuranceStatuses.getValueByName(value);
        } else if (dataType === 'LeadStatus') {
            formattedValue = Enums.LeadStatuses.getValueByName(value);
        } else if (dataType === 'PlanType') {
            formattedValue = Enums.PlanTypes.getValueByName(value);
        } else if (dataType === 'BillingStatus') {
            formattedValue = Enums.BillingStatuses.getValueByName(value);
        } else if (dataType === 'OrderType') {
            formattedValue = Enums.OrderTypes.getValueByName(value);
        } else if (dataType === 'LeadEmailTemplate') {
            formattedValue = Enums.LeadEmailTemplates.getValueByName(value);
        } else if (dataType === 'OrderEmailTemplate') {
            formattedValue = Enums.OrderEmailTemplates.getValueByName(value);
        } else if (dataType === 'CoveredEntityType') {
            formattedValue = Enums.CoveredEntityTypes.getValueByName(value);
        } else if (dataType === 'PolicyType') {
            formattedValue = Enums.PolicyTypes.getValueByName(value);
        } else if (dataType === 'PatientRelationshipToSubscriber') {
            formattedValue = Enums.PatientRelationshipToSubscribers.getValueByName(value);
        } else if (dataType === 'SelfIdentifiedGender') {
            formattedValue = Enums.SelfIdentifiedGenders.getValueByName(value);
        } else if (dataType === 'AgeCategory') {
            formattedValue = Enums.AgeCategories.getValueByName(value);
        } else if (dataType === 'SelfIdentifiedRace') {
            formattedValue = Enums.SelfIdentifiedRaces.getValueByName(value);
        } else if (dataType === 'SelfIdentifiedEthnicity') {
            formattedValue = Enums.SelfIdentifiedEthnicities.getValueByName(value);
        } else if (dataType === 'CovidTestingReason') {
            formattedValue = Enums.CovidTestingReasons.getValueByName(value);
        } else if (dataType === 'CovidSymptom') {
            formattedValue = Enums.CovidSymptoms.getValueByName(value);
        } else if (dataType === 'CovidVaccinationStatus') {
            formattedValue = Enums.CovidVaccinationStatuses.getValueByName(value);
        } else if (dataType === 'YesNoNoAnswer') {
            formattedValue = Enums.YesNoNoAnswer.getValueByName(value);
        } else if (dataType === 'MessageStatus') {
            formattedValue = Enums.MessageStatuses.getValueByName(value);
        } else if (dataType === 'MessageDirection') {
            formattedValue = Enums.MessageDirections.getValueByName(value);
        } else if (dataType === 'ActivityType') {
            formattedValue = Enums.ActivityTypes.getValueByName(value);
        } else if (dataType === 'ActivityDirection') {
            formattedValue = Enums.ActivityDirections.getValueByName(value);
        } else if (dataType === 'CoveredEntityRole') {
            formattedValue = Enums.CoveredEntityRoles.getValueByName(value);
        } else if (dataType === 'DocumentType') {
            formattedValue = Enums.DocumentTypes.getValueByName(value);
        } else if (dataType === 'PatientDocumentType') {
            formattedValue = Enums.PatientDocumentTypes.getValueByName(value);
        } else if (dataType === 'DocumentReviewStatus') {
            formattedValue = Enums.DocumentReviewStatuses.getValueByName(value);
        } else if (dataType === 'ProductStatus') {
            formattedValue = Enums.ProductStatuses.getValueByName(value);
        } else if (dataType === 'StockStatus') {
            formattedValue = Enums.StockStatuses.getValueByName(value);
        } else if (dataType === 'TaxStatus') {
            formattedValue = Enums.TaxStatuses.getValueByName(value);
        } else if (dataType === 'SubscriptionLimit') {
            formattedValue = Enums.SubscriptionLimits.getValueByName(value);
        } else if (dataType === 'ProductType') {
            formattedValue = Enums.ProductTypes.getValueByName(value);
        } else if (dataType === 'ShippingCalculationType') {
            formattedValue = Enums.ShippingCalculationTypes.getValueByName(value);
        } else if (dataType === 'PaymentMethod') {
            formattedValue = Enums.PaymentMethods.getValueByName(value);
        } else if (dataType === 'PaymentStatus') {
            formattedValue = Enums.PaymentStatuses.getValueByName(value);
        } else if (dataType === 'DiscountType') {
            formattedValue = Enums.DiscountTypes.getValueByName(value);
        } else if (dataType === 'DiscountTarget') {
            formattedValue = Enums.DiscountTargets.getValueByName(value);
        } else if (dataType === 'CouponDiscountTargetType') {
            formattedValue = Enums.CouponDiscountTargetTypes.getValueByName(value);
        } else if (dataType === 'CouponDiscountVariantScope') {
            formattedValue = Enums.CouponDiscountVariantScopes.getValueByName(value);
        } else if (dataType === 'CommercialEquivalencyVariantMatchStrategy') {
            formattedValue = Enums.CommercialEquivalencyVariantMatchStrategies.getValueByName(value);
        } else if (dataType === 'FunnelChoiceSetRenderMode') {
            formattedValue = Enums.FunnelChoiceSetRenderModes.getValueByName(value);
        } else if (dataType === 'FunnelChoiceProductResolutionMode') {
            formattedValue = Enums.FunnelChoiceProductResolutionModes.getValueByName(value);
        } else if (dataType === 'FunnelChoiceDefaultVariantStrategy') {
            formattedValue = Enums.FunnelChoiceDefaultVariantStrategies.getValueByName(value);
        } else if (dataType === 'MedicationTransitionSurveyReuseMode') {
            formattedValue = Enums.MedicationTransitionSurveyReuseModes.getValueByName(value);
        } else if (dataType === 'MedicationTransitionDoseStrategy') {
            formattedValue = Enums.MedicationTransitionDoseStrategies.getValueByName(value);
        } else if (dataType === 'MedicationTransitionFutureBundleCountMode') {
            formattedValue = Enums.MedicationTransitionFutureBundleCountModes.getValueByName(value);
        } else if (dataType === 'MedicationTransitionScopeType') {
            formattedValue = Enums.MedicationTransitionScopeTypes.getValueByName(value);
        } else if (dataType === 'MedicationTransitionLogStatus') {
            formattedValue = Enums.MedicationTransitionLogStatuses.getValueByName(value);
        } else if (dataType === 'MedicationTransitionType') {
            formattedValue = Enums.MedicationTransitionTypes.getValueByName(value);
        } else if (dataType === 'DuplicateCheckScope') {
            formattedValue = Enums.DuplicateCheckScopes.getValueByName(value);
        } else if (dataType === 'DuplicateCheckMode') {
            formattedValue = Enums.DuplicateCheckModes.getValueByName(value);
        } else if (dataType === 'DuplicateBlockingStatus') {
            formattedValue = Enums.DuplicateBlockingStatuses.getValueByName(value);
        } else if (dataType === 'EntityType') {
            formattedValue = Enums.EntityTypes.getValueByName(value);
        } else if (dataType === 'SurveyFlowKey') {
            formattedValue = Enums.SurveyFlowKeys.getValueByName(value);
        } else if (dataType === 'SurveyScope') {
            formattedValue = Enums.SurveyScopes.getValueByName(value);
        } else if (dataType === 'SiteEventStepName') {
            formattedValue = Enums.SiteEventStepNames.getValueByName(value) || value;
        } else if (dataType === 'VaccinationStatus') {
            formattedValue = Enums.VaccinationStatuses.getValueByName(value);
        } else if (dataType === 'VaccinationRequirement') {
            formattedValue = Enums.VaccinationRequirements.getValueByName(value);
        } else if (dataType === 'VaccinationType') {
            formattedValue = Enums.VaccinationTypes.getValueByName(value);
        } else if (dataType === 'TestStatus') {
            formattedValue = Enums.TestStatuses.getValueByName(value);
        } else if (dataType === 'UserTestUserResult') {
            formattedValue = Enums.UserTestUserResults.getValueByName(value);
        } else if (dataType === 'UserTestClinicianResult') {
            formattedValue = Enums.UserTestClinicianResults.getValueByName(value);
        } else if (dataType === 'UserTestResultStatus') {
            formattedValue = Enums.UserTestResultStatuses.getValueByName(value);
        } else if (dataType === 'UserTestStatus') {
            formattedValue = Enums.UserTestStatuses.getValueByName(value);
        } else if (dataType === 'TestSpecimen') {
            formattedValue = Enums.TestSpecimens.getValueByName(value);
        } else if (dataType === 'TransactionType') {
            formattedValue = Enums.TransactionTypes.getValueByName(value);
        } else if (dataType === 'TransactionStatus') {
            formattedValue = Enums.TransactionStatuses.getValueByName(value);
        } else if (dataType === 'TransactionResultCode') {
            formattedValue = Enums.TransactionResultCodes.getValueByName(value);
        } else if (dataType === 'AVSResponseCode') {
            formattedValue = Enums.AVSResponseCodes.getValueByName(value);
        } else if (dataType === 'CVVResponseCode') {
            formattedValue = Enums.CVVResponseCodes.getValueByName(value);
        } else if (dataType === 'EncounterType') {
            formattedValue = Enums.EncounterTypes.getValueByName(value);
        } else if (dataType === 'EncounterStatus') {
            formattedValue = Enums.EncounterStatuses.getValueByName(value);
        } else if (dataType === 'PendingMessageStatus') {
            formattedValue = Enums.PendingMessageStatuses.getValueByName(value);
        } else if (dataType === 'PrescriptionStatus') {
            formattedValue = Enums.PrescriptionStatuses.getValueByName(value);
        } else if (dataType === 'PrescriptionGroupStatus') {
            formattedValue = Enums.PrescriptionGroupStatuses.getValueByName(value);
        } else if (dataType === 'VoucherStatus') {
            formattedValue = Enums.VoucherStatuses.getValueByName(value);
        } else if (dataType === 'RefundMethod') {
            formattedValue = Enums.RefundMethods.getValueByName(value);
        } else if (dataType === 'DocumentRequirement') {
            formattedValue = Enums.DocumentRequirements.getValueByName(value);
        } else if (dataType === 'EncounterVisitType') {
            formattedValue = Enums.EncounterVisitTypes.getValueByName(value);
        } else if (dataType === 'PayoutMethod') {
            formattedValue = Enums.PayoutMethods.getValueByName(value);
        } else if (dataType === 'PayoutStatus') {
            formattedValue = Enums.PayoutStatuses.getValueByName(value);
        } else if (dataType === 'CustomerOrderStatus') {
            formattedValue = Enums.CustomerOrderStatuses.getValueByName(value);
        } else if (dataType === 'AffiliateRole') {
            formattedValue = Enums.AffiliateRoles.getValueByName(value);
        } else if (dataType === 'PartnerRole') {
            formattedValue = Enums.PartnerRoles.getValueByName(value);
        } else if (dataType === 'CheckInType') {
            formattedValue = Enums.CheckInTypes.getValueByName(value);
        } else if (dataType === 'CheckInStatus') {
            formattedValue = Enums.CheckInStatuses.getValueByName(value);
        } else if (dataType === 'MealPlanStatus') {
            formattedValue = Enums.MealPlanStatuses.getValueByName(value);
        } else if (dataType === 'MealType') {
            formattedValue = Enums.MealTypes.getValueByName(value);
        } else if (dataType === 'MealDay') {
            formattedValue = Enums.MealDays.getValueByName(value);
        } else if (dataType === 'MealPlanReviewStatus') {
            formattedValue = Enums.MealPlanReviewStatuses.getValueByName(value);
        } else if (dataType === 'VendorPaymentMethod') {
            formattedValue = Enums.VendorPaymentMethods.getValueByName(value);
        } else if (dataType === 'TitrationSchedule') {
            formattedValue = Enums.TitrationSchedules.getValueByName(value);
        } else if (dataType === 'EventType') {
            formattedValue = Enums.EventTypes.getValueByName(value);
        } else if (dataType === 'EventStatus') {
            formattedValue = Enums.EventStatuses.getValueByName(value);
        } else if (dataType === 'EventPlatform') {
            formattedValue = Enums.EventPlatforms.getValueByName(value);
        } else if (dataType === 'CommunityType') {
            formattedValue = Enums.CommunityTypes.getValueByName(value);
        } else if (dataType === 'CommunityPrivacy') {
            formattedValue = Enums.CommunityPrivacies.getValueByName(value);
        } else if (dataType === 'TaskCategory') {
            formattedValue = Enums.TaskCategories.getValueByName(value);
        } else if (dataType === 'TaskType') {
            formattedValue = Enums.TaskTypes.getValueByName(value);
        } else if (dataType === 'TicketChannel') {
            formattedValue = Enums.TicketChannels.getValueByName(value);
        } else if (dataType === 'EscalationLevel') {
            formattedValue = Enums.EscalationLevels.getValueByName(value);
        } else if (dataType === 'TicketEventType') {
            formattedValue = Enums.TicketEventTypes.getValueByName(value);
        } else if (dataType === 'SupportReplyTemplateChannel') {
            formattedValue = Enums.SupportReplyTemplateChannels.getValueByName(value);
        } else if (dataType === 'SupportHandoffType') {
            formattedValue = Enums.SupportHandoffTypes.getValueByName(value);
        } else if (dataType === 'SupportRoutingStatus') {
            formattedValue = Enums.SupportRoutingStatuses.getValueByName(value);
        } else if (dataType === 'SupportPresenceMode') {
            formattedValue = Enums.SupportPresenceModes.getValueByName(value);
        } else if (dataType === 'SupportViewScope') {
            formattedValue = Enums.SupportViewScopes.getValueByName(value);
        } else if (dataType === 'NewDashboardTutorialStatus') {
            formattedValue = Enums.NewDashboardTutorialStatuses.getValueByName(value);
        } else if (dataType === 'TaskStatus') {
            formattedValue = Enums.TaskStatuses.getValueByName(value);
        } else if (dataType === 'TaskPriority') {
            formattedValue = Enums.TaskPriorities.getValueByName(value);
        } else if (dataType === 'CancellationReason') {
            formattedValue = Enums.CancellationReasons.getValueByName(value);
        } else if (dataType === 'PauseReason') {
            formattedValue = Enums.PauseReasons.getValueByName(value);
        } else if (dataType === 'SatisfactionRating') {
            formattedValue = Enums.SatisfactionRatings.getValueByName(value);
        } else if (dataType === 'RecommendationOption') {
            formattedValue = Enums.RecommendationOptions.getValueByName(value);
        } else if (dataType === 'CancellationRequestStatus') {
            formattedValue = Enums.CancellationRequestStatuses.getValueByName(value);
        } else if (dataType === 'Priority') {
            formattedValue = Enums.Priorities.getValueByName(value);
        } else if (dataType === 'CancellationRequestResolutionType') {
            formattedValue = Enums.CancellationRequestResolutionTypes.getValueByName(value);
        } else if (dataType === 'CancellationRequestRetentionOfferType') {
            formattedValue = Enums.CancellationRequestRetentionOfferTypes.getValueByName(value);
        } else if (dataType === 'Carrier') {
            formattedValue = Enums.Carriers.getValueByName(value);
        } else if (dataType === 'CarrierShippingMethod') {
            formattedValue = Enums.CarrierShippingMethods.getValueByName(value);
        } else if (dataType === 'MealPlanGoal') {
            formattedValue = Enums.MealPlanGoals.getValueByName(value);
        } else if (dataType === 'MedicationAdministrationRoute') {
            formattedValue = Enums.MedicationAdministrationRoutes.getValueByName(value);
        } else if (dataType === 'MedicationInjectionSite') {
            formattedValue = Enums.MedicationInjectionSites.getValueByName(value);
        } else if (dataType === 'HydrationStatus') {
            formattedValue = Enums.HydrationStatuses.getValueByName(value);
        } else if (dataType === 'WellnessResponseScore') {
            formattedValue = Enums.WellnessResponseScores.getValueByName(String(value));
        } else if (dataType === 'AddOnQuantityMode') {
            formattedValue = Enums.AddOnQuantityModes.getValueByName(value);
        } else if (dataType === 'AddOnScope') {
            formattedValue = Enums.AddOnScopes.getValueByName(value);
        } else if (dataType === 'AddOnShipmentQuantityMode') {
            formattedValue = Enums.AddOnShipmentQuantityModes.getValueByName(value);
        } else if (dataType === 'AddOnSource') {
            formattedValue = Enums.AddOnSources.getValueByName(value);
        } else if (dataType === 'EmailSource') {
            formattedValue = Enums.EmailSources.getValueByName(value);
        } else if (dataType === 'EmailDeliveryStatus') {
            formattedValue = Enums.EmailDeliveryStatuses.getValueByName(value);
        } else if (dataType === 'CommunicationChannel') {
            formattedValue = Enums.CommunicationChannels.getValueByName(value);
        } else if (dataType === 'CommunicationClassification') {
            formattedValue = Enums.CommunicationClassifications.getValueByName(value);
        } else if (dataType === 'CommunicationPreferenceEventAction') {
            formattedValue = Enums.CommunicationPreferenceEventActions.getValueByName(value);
        } else if (dataType === 'CommunicationPreferenceSource') {
            formattedValue = Enums.CommunicationPreferenceSources.getValueByName(value);
        } else if (dataType === 'WeightHistorySource') {
            formattedValue = Enums.WeightHistorySources.getValueByName(value);
        } else if (dataType === 'EmailIngestionDisposition') {
            formattedValue = Enums.EmailIngestionDispositions.getValueByName(value);
        } else if (dataType === 'EmailIngestionReason') {
            formattedValue = Enums.EmailIngestionReasons.getValueByName(value);
        } else if (dataType === 'GmailImportLogStatus') {
            formattedValue = Enums.GmailImportLogStatuses.getValueByName(value);
        } else if (dataType === 'GmailImportLogReason') {
            formattedValue = Enums.GmailImportLogReasons.getValueByName(value);
        } else if (dataType === 'OrderGroupStatus') {
            formattedValue = Enums.OrderGroupStatuses.getValueByName(value);
        } else if (dataType === 'OrderGroupType') {
            formattedValue = Enums.OrderGroupTypes.getValueByName(value);
        } else if (dataType === 'EmailTemplateType') {
            formattedValue = Enums.EmailTemplateTypes.getValueByName(value);
        } else if (dataType === 'OtpChannel') {
            formattedValue = Enums.OtpChannels.getValueByName(value);
        } else if (dataType === 'BiomarkerFrequency') {
            formattedValue = Enums.BiomarkerFrequencies.getValueByName(value);
        } else if (dataType === 'SexApplicability') {
            formattedValue = Enums.SexApplicability.getValueByName(value);
        } else if (dataType === 'PanelType') {
            formattedValue = Enums.PanelTypes.getValueByName(value);
        } else if (dataType === 'TestScheduleType') {
            formattedValue = Enums.TestScheduleTypes.getValueByName(value);
        } else if (dataType === 'CollectionMethod') {
            formattedValue = Enums.CollectionMethods.getValueByName(value);
        } else if (dataType === 'LabInterpretation') {
            formattedValue = Enums.LabInterpretations.getValueByName(value);
        } else if (dataType === 'OptimalInterpretation') {
            formattedValue = Enums.OptimalInterpretations.getValueByName(value);
        } else if (dataType === 'HealthCategory') {
            formattedValue = Enums.HealthCategories.getValueByName(value);
        } else if (dataType === 'BiomarkerClassification') {
            formattedValue = Enums.BiomarkerClassifications.getValueByName(value);
        } else if (dataType === 'UserTestTriggerType') {
            formattedValue = Enums.UserTestTriggerTypes.getValueByName(value);
        } else if (dataType === 'BiomarkerValueType') {
            formattedValue = Enums.BiomarkerValueTypes.getValueByName(value);
        } else if (dataType === 'HealthScoreLabel') {
            formattedValue = Enums.HealthScoreLabels.getValueByName(value);
        } else if (dataType === 'InsightType') {
            formattedValue = Enums.InsightTypes.getValueByName(value);
        } else if (dataType === 'InsightPriority') {
            formattedValue = Enums.InsightPriorities.getValueByName(value);
        } else if (dataType === 'InsightActionType') {
            formattedValue = Enums.InsightActionTypes.getValueByName(value);
        } else {
            formattedValue = value;
        }

        return formattedValue;
    } else {
        return '';
    }
};
